export default __webpack_public_path__ + "img/img_niam-beef54a88a7b65880209ce007e72fdde.png";